import theme from "../styles/Theme";
import { StyleWookey } from "../styles/StyleMe"
import { StyleSperator, StyleDivision } from '../styles/StyleCommon'

const Me = () => {
    return (
        <div>
            <StyleDivision>Wookey🧑‍💻</StyleDivision>
            <blockquote>
                <StyleWookey theme={theme}>
                    <div>직관적이고 유연한 설계를 바탕으로 대화하기 쉬운 코드를 만들고, 이유 있는 코드로 동료에게 영감을 주는 개발자를 지향합니다.<br></br>
                         동료들에게 ‘함께 일하고 싶은 개발자’로 기억되는 것을 목표로 하고 있습니다.
                    </div>
                </StyleWookey>
            </blockquote>
        </div>
    )
}

export default Me

